export const regionList = (state, rootState) => {
	return state.regionList;
}

export const regionSelectors = (state, rootState) => {
	return state.regionSelectors;
}

export const objRegionEdit = (state, rootState) => {
	return state.objRegionEdit;
}

export const regionChildren = (state, rootState) => {
	return state.regionChildren;
}

export const regionParents = (state, rootState) => {
	return state.regionParents;
}

export const regionSearch = (state, rootState) => {
	return state.regionSearch;
}